import Emitter from 'tiny-emitter'

const emitter = new Emitter()

export default (app) => {
  app.config.globalProperties.$emitter = emitter
}
